export interface User{
    id: string;
    username: string;
    email: string;
    admin: number
}
export interface Article{
    id: string,
    title: string,
    description?: string,
    created_at: string,
    updated_at: string
}
export interface Resource {
    id: number,
    type: 'pdf' | 'link',
    title: string,
    value?: string,
    description?: string,
    created_at: string,
    updated_at: string,
    tags?: string[],
    category_name: string,
    category_id: number,
    thumbnail_url?: string
}
export interface MonthEvent{
    event_id?: string,
    month_id?: number,
    event_name: string,
    event_description: string,
    event_day_number: number,
    event_starting_time: string,
    event_ending_time: string,
    event_day: number,
    is_private: boolean
}
export interface Month{
    month_info: {
       name: string,
       number: number,
       starting_day: number,
       month_id: number
    },
    month: {[index: number]: MonthEvent[]}
}
export interface TelegramUser{
    name: string,
    user_id: number,
    status: string
}
export class Box<T>{
    private _value: T;
    constructor(v: T){
        this._value = v;
    }
    get value(){ return this._value; }
    setValue(value: T) { this._value = value; }
}
export interface Result<T, E> {
    ok: Box<T> | null,
    err: Box<E> | null
}
export const resultify = async<T>(promise: Promise<T>): Promise<Result<T, Error>> => {

    try{
        const result = await promise;
        return {
            ok: new Box<T>(result),
            err: null
        }
    }catch(err){
        return {
            ok: null,
            err: new Box<Error>(err as Error)
        }
    }

}